<template>
  <div id="app">
    <!-- Show admin layout for admin routes -->
    <AppLayout
      v-if="$route.meta.requiresAuth && isAuthenticated && userType === 'admin'"
    >
      <router-view />
    </AppLayout>

    <!-- Show public layout for public routes (excluding login/auth routes) -->
    <PublicLayout
      v-else-if="
        (!$route.meta.requiresAuth || userType === 'user') &&
        !$route.meta.requiresGuest
      "
    >
      <router-view />
    </PublicLayout>

    <!-- Show plain view for login/auth routes -->
    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLayout from "@/components/Layout/AppLayout.vue";
import PublicLayout from "@/components/Layout/PublicLayout.vue";

export default {
  name: "App",
  components: {
    AppLayout,
    PublicLayout,
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "userType"]),
  },
  async created() {
    // Initialize auth state on app start
    await this.$store.dispatch("auth/initializeAuth");
  },
};
</script>

<style>
#app {
  min-height: 100vh;
  overflow-x: hidden; /* Only hide horizontal overflow */
}

/* Ensure body and html allow scrolling */
html,
body {
  height: 100%;
  overflow-x: hidden;
}

/* Allow scrolling on main content areas */
.router-view {
  overflow-y: auto;
}
</style>
